import country from '$modules/country/routes'
import state from '$modules/state/routes'

export default [
  {
    path: 'address',
    meta: {
      title: 'Addresses',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'place'
    },
    component: () => import('./pages/index'),
    redirect: 'address/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'address',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'address',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'address',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ].concat(country, state)
  }
]
